import { useState } from "react";
import { useIntl } from "react-intl";
import { Box, IconButton, makeStyles } from "@material-ui/core";
import { toast } from "react-toastify";
import { WhatsAppIcon, TelegramIcon } from "components/common/SrIcon";
import { copyToClipboard } from "utils";
import { SrDialog, SrDropdown } from "..";

const useStyles = makeStyles((theme) => ({
  dialogCustomSize: {
    maxWidth: "16rem",
  },
  btnShare: {
    width: "4rem",
    height: "4rem",
  },
}));

type ActionsTableProps = {
  url: string;
  type: string;
};

const ActionsTable = ({ url, type }: ActionsTableProps) => {
  const [shareDialog, setShareDialog] = useState(false);
  const [urlToShare, setUrlToShare] = useState("");

  const intl = useIntl();
  const classes = useStyles();

  const handleDownload = () => window.open(url, "_blank");
  const handleShare = () => {
    setShareDialog(true);
    setUrlToShare(url);
  };
  const handleCopy = () => {
    copyToClipboard(url);
    toast.success(intl.formatMessage({ id: "common.copied" }));
  };

  const shareHandler = (share: string) => {
    url = "";
    const message = {
      voucher: intl.formatMessage({
        id: "common.shareVoucher",
      }),
      ticket: intl.formatMessage({
        id: "common.shareVoucher",
      }),
      order: intl.formatMessage({
        id: "common.shareOrder",
      }),
    }[type];

    if (share === "whatsapp") {
      url = `https://api.whatsapp.com/send?text=${message} ${urlToShare}`;
    }
    if (share === "telegram") {
      url = `https://telegram.me/share/url?text=${message} &url=${urlToShare}`;
    }
    const newWnd = window;
    newWnd.opener = null;
    newWnd.open(url, "_blank");
    setShareDialog(false);
  };

  const actions = [
    {
      key: "download",
      content: intl.formatMessage({ id: "common.download" }),
      onClick: handleDownload,
    },
    {
      key: "copy",
      content: intl.formatMessage({ id: "common.copy" }),
      onClick: handleCopy,
    },
    {
      key: "share",
      content: intl.formatMessage({ id: "common.share" }),
      onClick: handleShare,
    },
  ];

  return (
    <>
      {/* 
      // @ts-ignore */}
      <SrDialog
        handleClose={() => setShareDialog(false)}
        open={shareDialog}
        heading={intl.formatMessage({ id: "common.share" })}
        classes={{ paper: classes.dialogCustomSize }}
      >
        <Box display="flex" justifyContent="center">
          <IconButton
            aria-label="WhatsApp"
            onClick={() => shareHandler("whatsapp")}
          >
            <WhatsAppIcon className={classes.btnShare} />
          </IconButton>
          <IconButton
            aria-label="Telegram"
            onClick={() => shareHandler("telegram")}
          >
            <TelegramIcon className={classes.btnShare} />
          </IconButton>
        </Box>
      </SrDialog>
      {/* 
      // @ts-ignore */}
      <SrDropdown actions={actions} />
    </>
  );
};

export default ActionsTable;
